module.exports = __webpack_public_path__ + "img/ahorcado0.9c98857d.jpg";